require('z-shop-js-env');
require('z-shop-css-env/style.css');
require('@zalando-internal/z-shop-ui/dist/z-shop-ui.css');

var wrapper = document.createElement('div');
wrapper.className = 'z-svg-res-container';
wrapper.innerHTML = require('@zalando-internal/z-shop-ui/dist/icons.svg');
// Icons shouldn't have gradients, they may not render them because of hidden div
wrapper.style.display = 'none';
// Insert on top of everything in the body to not break the fragment identification
// Polling is needed since document.body is null for hidden tabs in Firefox
(function pollForBody() {
    if (document.body) {
        document.body.insertBefore(wrapper, document.body.firstChild);
    } else {
        setTimeout(pollForBody, 30);
    }
})();

exports.classnames = require('classnames');
exports['z-shop-ui'] = require('@zalando-internal/z-shop-ui');
exports.react = require('react');
exports['react-dom'] = require('react-dom');
exports['z-shop-event-bus'] = require('z-shop-event-bus');
exports.tranzlate = require('tranzlate');
exports['zalando-consent-api'] = require('@zalando-internal/zalando-consent-api');

if (window.location.search.indexOf('translationDebuggingMode=1') >= 0) {
    exports.tranzlate.passThrough = true;
}

exports['safe-fetch'] = require('./fetch-extension');
